export default __webpack_public_path__ + "static/media/laptop.ed3e6432.jpg";